import React from 'react';
import Rating, { RatingProps } from '@material-ui/lab/Rating';
import { withStyles } from '@material-ui/core/styles';
import { colorSet } from '@components/Provider';

interface CustomizedRatingProps {
  name: string;
  size?: RatingProps['size'];
  value: RatingProps['value'];
  onChange: (newValue: number | null) => void;
}

const CustomizedRating: React.FC<CustomizedRatingProps> = ({
  name,
  size,
  value,
  onChange
}: CustomizedRatingProps) => {
  return (
    <StyledRating
      name={name}
      size={size}
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
    />
  );
};

const StyledRating = withStyles({
  icon: {
    '& .MuiSvgIcon-root': {
      width: 40,
      height: 40
    }
  },
  iconFilled: {
    color: colorSet.primary500
  },
  iconHover: {
    color: colorSet.primary600
  }
})(Rating);

export default CustomizedRating;
